export { default as Img200 } from './processed/200/Drone.jpg';
export { default as Img400 } from './processed/400/Drone.jpg';
export { default as Imgthumb } from './processed/thumb/Drone.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Drone.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Drone.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      216,
      35,
      39
    ],
    "_population": 22,
    "_hsl": [
      0.9963167587476979,
      0.7211155378486055,
      0.49215686274509807
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      95,
      24,
      28
    ],
    "_population": 180,
    "_hsl": [
      0.9906103286384976,
      0.5966386554621849,
      0.23333333333333334
    ]
  },
  "Muted": {
    "_rgb": [
      140,
      116,
      100
    ],
    "_population": 3,
    "_hsl": [
      0.06666666666666664,
      0.1666666666666667,
      0.47058823529411764
    ]
  },
  "LightMuted": {
    "_rgb": [
      205,
      191,
      179
    ],
    "_population": 184,
    "_hsl": [
      0.07692307692307696,
      0.2063492063492065,
      0.7529411764705882
    ]
  },
  "DarkMuted": {
    "_rgb": [
      47,
      73,
      83
    ],
    "_population": 1010,
    "_hsl": [
      0.5462962962962964,
      0.27692307692307694,
      0.2549019607843137
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Drone.js